import type React from "react";
import { ReactComponent as Svg } from "./assets/check-icon.svg";
import * as styles from "./Icon.module.scss";

type LegWinProps = React.SVGProps<SVGSVGElement>;

export const LegWin = ({ className, ...props }: LegWinProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
